import { Controller } from 'stimulus';

export default class extends Controller {
  #closeWhenClickedOutside;

  connect() {
    this.#closeWhenClickedOutside = this.#closeIfOutsideClick.bind(this);
    document.addEventListener('click', this.#closeWhenClickedOutside);
  }

  disconnect() {
    document.removeEventListener('click', this.#closeWhenClickedOutside);
  }

  isInside(target) {
    return this.element.contains(target);
  }

  #closeIfOutsideClick(event) {
    const keepOpened = this.isInside(event.target) && this._opened;
    this._opened = keepOpened;
  }
}
